import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { Functionality } from '../..';
import { DialogTitleWithTypography } from '../../../../../../components/DialogTitleWithTypography';
import { useUnsafeTranslation } from '../../../../../../i18next';
import { useRoutes } from '../../../../../../routes';
import {
  IntegrationConfigurationButton,
  IntegrationSetupDialogProperties
} from '../common';

const NAME = 'Email CSV';

const Content = styled(DialogContent)((p) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: p.theme.spacing(2)
}));

const InfoDialog = ({
  open,
  onClose
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const { t } = useUnsafeTranslation();
  const { ROUTES } = useRoutes();
  const theme = useTheme();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitleWithTypography>
        {NAME} {t('org.integrations.integration')}
      </DialogTitleWithTypography>
      <Content>
        <Typography component="p" variant="body1">
          {t(
            'Send CSV files to a unique email address. Dado will automatically pick up and import the data.'
          )}
        </Typography>
        <Typography component="p" variant="body1">
          {t('Go to ')}
          <Link
            style={{
              color: theme.custom.colors.primary.main
            }}
            to={ROUTES.users.imports.importSources.url()}
          >
            {t('Import Sources')}
          </Link>{' '}
          {t('to configure your integration.')}
        </Typography>
      </Content>
      <DialogActions>
        <Button onClick={onClose}>{t('Close')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export const EmailCsvSettingsButton = ({
  functionalities,
  interactive
}: {
  functionalities: Functionality[];
  interactive: boolean;
}) => {
  return (
    <IntegrationConfigurationButton
      functionalities={functionalities}
      name={NAME}
      logoUrl="/images/integrations-logos/email-csv.svg"
      active={false}
      interactive={interactive}
      renderSetupDialog={({
        open,
        onClose
      }: IntegrationSetupDialogProperties) => (
        <InfoDialog open={open} onClose={onClose} />
      )}
    />
  );
};
